<template>
    <div>
        <div v-for="(rule, index) in ruleList" :key="rule.arId">
            <LabelContent :title="rule.arLevel + '级规则'">
                <div slot="btns">
                    <el-button size="small" type="success"
                               v-if="rule.arId != 0"
                               @click="onShowRuleNofity(rule)">通知对象
                    </el-button>
                    <el-button size="small" type="warning"
                               v-if="rule.arId != 0"
                               @click="onUpdateSubmit(rule)">提交修改
                    </el-button>
                    <el-button size="small" type="danger"
                               v-if="index == ruleList.length-1 && rule.arId != 0"
                               @click="onDeleteRule(rule)">删除规则
                    </el-button>
                    <el-button size="small" type="success"
                               v-if="index == ruleList.length-1 && rule.arLevel < 3 && rule.arId != 0"
                               @click="onNewRule(rule)">添加规则
                    </el-button>
                    <el-button size="small" type="success"
                               v-if="rule.arId == 0"
                               @click="onNewSubmit(rule)">新增提交
                    </el-button>
                </div>
            </LabelContent>
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="rule" label-width="120px" class="unitWidth"
                         size="small">
                    <el-form-item label="作用范围">
                        <el-select v-model="rule.arScope" placeholder="请选择" @change="buildRuleScopeTree(rule)">
                            <!--<el-option label="公司" value="company"></el-option>-->
                            <el-option label="工厂" value="factory"></el-option>
                            <el-option label="车间" value="shop"></el-option>
                            <el-option label="工段" value="vsm"></el-option>
                            <el-option label="产线" value="line"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工厂">
                        <el-select v-model="rule.fcCode" placeholder="请选择" @change="buildRuleScopeTree(rule, 'factory')"
                                   :disabled="fcShow">
                            <!--:disabled="rule.arScope =='company'">-->
                            <el-option
                                v-for="factory in factoryList"
                                :key="factory.value"
                                :label="factory.label"
                                :value="factory.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="rule.shopCode" placeholder="请选择" @change="buildRuleScopeTree(rule, 'shop')"
                                   :disabled="rule.arScope =='factory'||rule.arScope=='company'">
                            <el-option
                                v-for="shop in rule.shopList"
                                :key="shop.value"
                                :label="shop.label"
                                :value="shop.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="rule.sectionCode" placeholder="请选择"
                                   @change="buildRuleScopeTree(rule, 'vsm')"
                                   :disabled="rule.arScope =='shop'|| rule.arScope =='factory'||rule.arScope=='company'">
                            <el-option
                                v-for="section in rule.sectionList"
                                :key="section.value"
                                :label="section.label"
                                :value="section.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="rule.lineCode" placeholder="请选择" @change="buildRuleScopeTree(rule, 'line')"
                                   :disabled="rule.arScope =='shop'|| rule.arScope =='factory'
                                    ||rule.arScope=='company'||rule.arScope=='vsm'">
                            <el-option
                                v-for="line in rule.lineList"
                                :key="line.value"
                                :label="line.label"
                                :value="line.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="安灯类型">
                        <el-select v-model="rule.atId" placeholder="请选择" @change="buildAnonTypeSelect(rule, 'at')">
                            <el-option
                                v-for="atype in aTList"
                                :key="atype.id"
                                :label="atype.label"
                                :value="atype.value">
                                <span style="float: left">{{atype.label}}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="安灯种类">
                        <el-select v-model="rule.acCode" placeholder="请选择" @change="buildAnonTypeSelect(rule)">
                            <el-option
                                v-for="acontent in rule.acList"
                                :key="acontent.id"
                                :label="acontent.label"
                                :value="acontent.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="安灯级别">
                        <el-select v-model="rule.arLevel" placeholder="请选择" clearable>
                            <el-option
                                v-for="level in andonLevelList"
                                :key="level.value"
                                :label="level.label"
                                :value="level.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="触发条件编号">
                        <el-input v-model.trim="rule.arCode" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="触发条件">
                        <el-input v-model.trim="rule.arTrigger" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="响应时间(分)">
                        <!--                        <el-input v-model.trim="rule.arResponseSpan" placeholder="请输入"></el-input>-->
                        <el-input-number v-model="rule.arResponseSpan" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="处理时间(分)">
                        <!--                        <el-input v-model.trim="rule.arSolveSpan" placeholder="请输入"></el-input>-->
                        <el-input-number v-model="rule.arSolveSpan" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="到达现场时间(分)">
                        <!--                        <el-input v-model.trim="rule.arSolveSpan" placeholder="请输入"></el-input>-->
                        <el-input-number v-model="rule.arArriveSpan" :min="0"></el-input-number>
                    </el-form-item>
                </el-form>
            </SearchBox>
        </div>
        <el-dialog title="安灯通知对象编辑" :visible.sync="ruleNotifyShow" width="50%">
            <div style="text-align: left">
                <el-tag :key="role.anrId" style="margin-left: 10px"
                        v-for="role in andonNotifyRoleList" closable
                        :disable-transitions="false" @close="onAndonNofityRoleDelete(role)">
                    {{role.roleName}}
                </el-tag>
                <div style="margin: 10px">
                    <el-select v-model="roleSelected" size="small" filterable placeholder="请选择"
                               style="margin-right: 20px">
                        <el-option
                            v-for="role in roleListToSelect"
                            :key="role.roleId"
                            :label="role.roleName"
                            :value="role.roleId">
                        </el-option>
                    </el-select>
                    <el-button size="small" @click="onRoleSelectSubmit">选择提交</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="ruleNotifyShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import AndonAPI from '@/libs/api_const/api_andon'

    export default {
        name: 'editRule',
        data() {
            return {
                //路由安灯规则ID
                routeRuleId: 0,
                //规则列表
                ruleList: [],
                //规则管理编辑传过来的工厂编码
                fcCode: '',
                //安灯级别
                andonLevelList: [
                    {
                        value: 1,
                        label: '一级'
                    },
                    {
                        value: 2,
                        label: '二级'
                    },
                    {
                        value: 3,
                        label: '三级'
                    }
                ],
                // 组织架构树
                factoryTree: [],
                // 安灯类型树
                andonTypelist: [],

                // 规则通知对象弹出框显示
                ruleNotifyShow: false,
                // 规则ID-通知对象维护使用
                ruleIdNotifyEdit: 0,
                // 角色列表
                roleList: [],
                roleListToSelect: [],
                // 规则通知对象列表
                andonNotifyRoleList: [],
                // 角色选择
                roleSelected: '',
                userInfo: {},
                ischeck: true,
                role: [],
                ifAdd: false,
                fcShow: false
            }
        },
        computed: {
            // 工厂下拉框列表
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: this.factoryTree[i].deptCode
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: this.factoryTree[i].deptCode
                            })
                        }
                    }
                }
                return arr
            },
            // 安灯类型下拉列表
            aTList: function() {
                var arr = []
                if (this.andonTypelist != undefined && this.andonTypelist.length > 0) {
                    for (var i = 0; i < this.andonTypelist.length; i++) {
                        arr.push({
                            label: this.andonTypelist[i].typeName,
                            id: this.andonTypelist[i].id,
                            value: this.andonTypelist[i].id
                        })
                    }
                }
                return arr
            }
        },
        created() {
            this.userInfo = this.$store.state.userInfo
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                    }
                    this.fcShow = true
                }
            }
            this.getDeptTree()
        },
        methods: {
            init() {
                if (this.$route.query.ruleId !== undefined) {
                    this.routeRuleId = this.$route.query.ruleId
                    this.fcCode = this.$route.query.fcCode
                } else {
                    this.$message.error('规则数据错误!')
                    return
                }
                if (this.ischeck) {
                    this.fcCode = this.userInfo.fcCode
                }
                //查询安灯类型-种类
                this.getAndonType(this.fcCode)

                if (this.routeRuleId == 0) {
                    // 新建安灯
                    this.ifAdd = true
                    this.fcShow = false
                    this.onNewRule({})
                } else {
                    // 查询安灯规则流
                    this.ifAdd = false
                    this.fcShow = true
                    this.$http.request({
                        url: AndonAPI.GetAndonRuleFlow,
                        params: {
                            ruleId: this.routeRuleId
                        }
                    }).then(resp => {
                        this.ruleList = resp.data
                        this.ruleList.forEach(rule => {
                            this.buildRuleScopeTree(rule)
                            this.buildAnonTypeSelect(rule)
                        })
                    })
                }
            },
            // 获取部门树
            getDeptTree() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.depart_tree,
                    params: {
                        from: 'manage'
                    }
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    this.init()
                })
            },
            // 获取安灯类型-种类
            getAndonType(fcCode) {
                let params = {}
                if (fcCode != undefined && fcCode != '') {
                    params['fcCode'] = fcCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getAndonRule,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.andonTypelist = response.data
                    }
                })
            },
            // 构建工厂-产线多级下拉框
            buildRuleScopeTree(rule, changeLevel) {
                // 计算下拉框值
                if (rule.fcCode !== '') {
                    let shops = []
                    this.factoryTree.forEach(fc => {
                        if (fc.deptCode === rule.fcCode)
                            shops = fc.child
                    })
                    rule.shopList = []
                    for (var i = 0; i < shops.length; i++) {
                        rule.shopList.push({
                            label: shops[i].deptName,
                            id: shops[i].deptID,
                            value: shops[i].deptCode
                        })
                    }
                } else {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        if (this.factoryTree[i].deptID == this.role.factoryId) {
                            rule.fcCode = this.factoryTree[i].fcCode
                        }
                    }
                }
                if (rule.shopCode !== '') {
                    let vsms = []
                    this.factoryTree.forEach(fc => {
                        fc.child.forEach(shop => {
                            if (shop.deptCode === rule.shopCode)
                                vsms = shop.child
                        })
                    })
                    rule.sectionList = []
                    for (var i = 0; i < vsms.length; i++) {
                        rule.sectionList.push({
                            label: vsms[i].deptName,
                            id: vsms[i].deptID,
                            value: vsms[i].deptCode
                        })
                    }
                }
                if (rule.sectionCode !== '') {
                    let lines = []
                    this.factoryTree.forEach(fc => {
                        fc.child.forEach(shop => {
                            shop.child.forEach(vsm => {
                                if (vsm.deptCode === rule.sectionCode)
                                    lines = vsm.child
                            })
                        })
                    })
                    rule.lineList = []
                    for (var i = 0; i < lines.length; i++) {
                        rule.lineList.push({
                            label: lines[i].deptName,
                            id: lines[i].deptID,
                            value: lines[i].deptCode
                        })
                    }
                }

                // 修改联动值
                if (changeLevel === 'factory') {
                    rule.lineCode = ''
                    rule.sectionCode = ''
                    rule.shopCode = ''
                    rule.atId = ''
                    rule.acCode = ''
                    rule.acList = []
                    this.getAndonType(rule.fcCode)
                } else if (changeLevel === 'shop') {
                    rule.lineCode = ''
                    rule.sectionCode = ''
                } else if (changeLevel === 'vsm') {
                    rule.lineCode = ''
                }

                // 空值处理
                if (rule.arScope === 'factory' || rule.arScope === 'company' || rule.arScope === 'shop'
                    || rule.arScope === 'vsm') {
                    rule.lineCode = ''
                    rule.lineList = []
                }
                if (rule.arScope === 'factory' || rule.arScope === 'company' || rule.arScope === 'shop') {
                    rule.sectionCode = ''
                    rule.sectionList = []
                }
                if (rule.arScope === 'factory' || rule.arScope === 'company') {
                    rule.shopCode = ''
                    rule.shopList = []
                }

                this.getRuleList(rule.fcCode)
                // 强制刷新
                this.$forceUpdate()
            },
            // 构建安灯类型-种类下拉框
            buildAnonTypeSelect(rule, changeLevel) {
                // 初始计算
                if (rule.atId === undefined)
                    rule.atId = ''
                if (rule.atId === '' && rule.acCode !== '') {
                    this.andonTypelist.forEach(at => {
                        if (at.contentList)
                            at.contentList.forEach(ac => {
                                if (ac.acCode === rule.acCode)
                                    rule.atId = at.id
                            })
                    })
                }
                // 空值处理
                if (changeLevel === 'at') {
                    rule.acCode = ''
                }
                // 计算联动值
                if (rule.atId !== '') {
                    rule.acList = []
                    this.andonTypelist.forEach(at => {
                        if (at.id === rule.atId && at.contentList) {
                            rule.acList = at.contentList.map(ac => {
                                return {
                                    label: ac.content,
                                    id: ac.acCode,
                                    value: ac.acCode
                                }
                            })
                        }
                    })
                }
                // 强制刷新
                this.$forceUpdate()
            },
            // 删除安灯规则
            onDeleteRule(rule) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 获取根规则ID
                    var rootRuleId = 0
                    if (this.ruleList.length > 1) {
                        rootRuleId = this.ruleList[0].arId
                    }
                    this.$http.request({
                        method: 'POST',
                        url: this.$api.deteleAndonRule + rule.arId
                    }).then(resp => {
                        if (resp.status == 100) {
                            // 路由调整
                            if (rootRuleId > 0 && rootRuleId != this.routeRuleId) {
                                this.$router.replace({
                                    path: '/editRule',
                                    query: {
                                        ruleId: rootRuleId,
                                        fcCode: rule.fcCode
                                    }
                                })
                            } else {
                                this.init()
                            }
                        } else {
                            this.$message.error(resp.message)
                        }
                    })
                })
            },
            // 添加安灯规则
            onNewRule(rule) {
                var newRule = {
                    acCode: rule.acCode ? rule.acCode : '',
                    acName: rule.acName ? rule.acName : '',
                    arArriveSpan: 12,
                    arCode: '',
                    arId: 0,
                    arLevel: rule.arLevel ? rule.arLevel + 1 : 1,
                    arNextId: 0,
                    arResponseSpan: 12,
                    arScope: rule.arScope ? rule.arScope : 'factory',
                    arSolveSpan: 120,
                    arTrigger: '',
                    arType: 'manual',
                    atId: rule.atId ? rule.atId : undefined,
                    checkLevel: 1,
                    fcCode: rule.fcCode ? rule.fcCode : this.userInfo.fcCode,
                    lineCode: rule.lineCode ? rule.lineCode : '',
                    sectionCode: rule.sectionCode ? rule.sectionCode : '',
                    shopCode: rule.shopCode ? rule.shopCode : '',
                    // 上一级安灯规则
                    lastRuleId: rule.arId ? rule.arId : ''
                }
                this.buildRuleScopeTree(newRule)
                this.buildAnonTypeSelect(newRule)
                this.getRuleList(rule.fcCode)
                this.ruleList.push(newRule)
            },
            ruleSubmitCheck(rule) {
                if (rule.acCode == '') {
                    this.$message.info('请选择安灯种类！')
                    return false
                }
                if (rule.arTrigger == '') {
                    this.$message.info('请输入触发条件')
                    return false
                }
                if (rule.arCode == '') {
                    this.$message.info('请输入触发条件编号')
                    return false
                }
                if (rule.arLevel == '' || rule.arLevel == undefined) {
                    this.$message.info('请选择级别')
                    return false
                }
                if (rule.arScope == '') {
                    this.$message.info('请选择范围')
                    return false
                }
                if (rule.arScope == 'factory' && !rule.fcCode) {
                    this.$message.info('请选择到工厂级')
                    return false
                } else if (rule.arScope == 'shop' && !rule.shopCode) {
                    this.$message.info('请选择到车间级')
                    return false
                } else if (rule.arScope == 'vsm' && !rule.sectionCode) {
                    this.$message.info('请选择到工段级')
                    return false
                } else if (rule.arScope == 'line' && !rule.lineCode) {
                    this.$message.info('请选择到产线级')
                    return false
                }
                if (rule.arResponseSpan == '' || rule.arResponseSpan == 0) {
                    this.$message.info('请输入响应时间')
                    return false
                }
                if (rule.arSolveSpan == '' || rule.arSolveSpan == 0) {
                    this.$message.info('请输入处理时间')
                    return false
                }
                if (rule.arArriveSpan == '' || rule.arArriveSpan == 0) {
                    this.$message.info('请输入到达现场时间')
                    return false
                }

                return true
            },
            // 添加安灯规则提交
            onNewSubmit(rule) {
                if (!this.ruleSubmitCheck(rule))
                    return

                let options = {
                    method: 'POST',
                    url: this.$api.addAndonRule,
                    data: rule,
                    params: {
                        lastRuleId: rule.lastRuleId ? rule.lastRuleId : 0
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        let rootRuleId = response.data
                        // 路由调整
                        if (rootRuleId > 0) {
                            this.$router.replace({
                                path: '/editRule',
                                query: {
                                    ruleId: rootRuleId,
                                    fcCode: rule.fcCode
                                }
                            })
                        }
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            // 安灯规则修改提交
            onUpdateSubmit(rule) {
                if (!this.ruleSubmitCheck(rule))
                    return
                let options = {
                    method: 'POST',
                    url: this.$api.editAndonRule,
                    data: rule
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.init()
                        this.$message.success('修改成功')
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            // 规则通知对象显示
            onShowRuleNofity(rule) {
                this.ruleIdNotifyEdit = rule.arId
                this.andonNotifyRoleList = []
                this.ruleNotifyShow = true
                this.getAndonNotifyRule()
                this.getRuleList(rule.fcCode)
            },
            getAndonNotifyRule() {
                let options = {
                    method: 'GET',
                    url: AndonAPI.GetAndonRuleNotify,
                    params: {
                        arId: this.ruleIdNotifyEdit
                    }
                }
                this.$http.request(options).then(response => {
                    this.roleListToSelect = JSON.parse(JSON.stringify(this.roleList))
                    if (response.data != undefined && response.data != '') {
                        if (response.status == 100 && response.data.length > 0) {
                            this.andonNotifyRoleList = response.data
                            this.andonNotifyRoleList.forEach(anr => {
                                for (var i = this.roleListToSelect.length - 1; i >= 0; i--) {
                                    if (this.roleListToSelect[i].roleId == anr.roleId)
                                        this.roleListToSelect.splice(i, 1)
                                }
                            })
                        }
                    } else {
                        this.andonNotifyRoleList = []
                    }
                })
            },
            // 角色列表获取
            getRuleList(fcCode) {
                let params = {}
                if (fcCode != undefined && fcCode != '') {
                    params['fcCode'] = fcCode
                }
                let options = {
                    method: 'GET',
                    url: this.$api.listRole,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.roleList = response.data
                    }
                })
            },
            // 角色选择提交
            onRoleSelectSubmit() {
                if (this.roleSelected == undefined || this.roleSelected == '') {
                    this.$message.error('请选择角色！！！')
                    return
                }
                let queryParams = {
                    roleId: this.roleSelected,
                    arId: this.ruleIdNotifyEdit
                }
                let options = {
                    method: 'post',
                    url: this.$api.addAndonRuleRole,
                    data: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.roleSelected = ''
                        this.getAndonNotifyRule()
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            // 角色删除
            onAndonNofityRoleDelete(role) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            params: {
                                anrId: role.anrId
                            },
                            url: this.$api.deleteAndonRuleRole
                        })
                        .then(response => {
                            this.getAndonNotifyRule()
                        })
                })
            }
        }
    }
</script>

<style scoped>
</style>
